// extracted by mini-css-extract-plugin
module.exports = {"lp-radio__wrapper":"Radio_lp-radio__wrapper__LHgbD","lp__radio":"Radio_lp__radio__H_jED"};